import { render, staticRenderFns } from "./moneyText.vue?vue&type=template&id=3f5e9eec&"
import script from "./moneyText.vue?vue&type=script&lang=js&"
export * from "./moneyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports